export default function ListChecks() {
    return (
        <header className="App-header">
            <h1>
                List of Checks
            </h1>
        </header>
    );
}